import { byUserInteraction, sendGoogleEvent } from '@html/_common/utils';

export default function AOTourPrivateOptionRequest(tourId, operatorId) {
  this.privateRequest = null;

  // GA
  this.eventCategory = 'Tour Detail';

  this.PERSONALIZED_TAB_BUTTON_CLASS = 'js-ao-tour-private-request_availability-personalized';
  this.PRIVATE_TAB_BUTTON_CLASS = 'js-ao-tour-private-request_availability-private';
  this.GROUP_TAB_BUTTON_CLASS = 'js-ao-tour-private-request_availability-group';

  this.initiate = () => {
    this.initializePopupTriggers();
    this.initializeAvailabilitySwitch();

    // Tracking privates
    byUserInteraction('load-private-tour', () => {
      sendGoogleEvent(
        this.eventCategory,
        'Travel Style',
        $('.ao-tour-above-fold ul.ao-tour-keep-exploring').children().map(() => $(this).text()).get()
          .join(),
        { nonInteraction: true },
      );
    });
  };

  this.initializePopupTriggers = () => {
    $('.js-ao-tour-above-fold__button-privatetour, .js-ao-tour-adventure-type__request-quote').on('click', (e) => {
      const $element = $(e.currentTarget);

      import(/* webpackChunkName: "AOTourPrivateRequestInteractions" */'@html/_common/private_request/private_request_interactions').then((module) => {
        const AOTourPrivateRequestInteractions = module.default;
        if (!this.privateRequest) {
          this.privateRequest = new AOTourPrivateRequestInteractions(tourId, operatorId);
        }
        if ($element.hasClass('js-ao-tour-above-fold__button-privatetour')) {
          this.privateRequest.handleAboveFoldTrigger();
        }
        if ($element.hasClass('js-ao-tour-adventure-type__request-quote')) {
          this.privateRequest.handleAdventureTypeTrigger();
        }
      });
    });
  };

  this.initializeAvailabilitySwitch = () => {
    $(`.${this.PERSONALIZED_TAB_BUTTON_CLASS}, .${this.GROUP_TAB_BUTTON_CLASS}, .${this.PRIVATE_TAB_BUTTON_CLASS}`).on('click', (e) => {
      const $element = $(e.currentTarget);

      import(/* webpackChunkName: "AOTourPrivateRequestInteractions" */'@html/_common/private_request/private_request_interactions').then((module) => {
        const AOTourPrivateRequestInteractions = module.default;

        if (!this.privateRequest) {
          this.privateRequest = new AOTourPrivateRequestInteractions(tourId, operatorId);
        }

        if ($element.hasClass(this.PERSONALIZED_TAB_BUTTON_CLASS)) {
          this.privateRequest.handlePersonalizedTabClick(e);
        }
        if ($element.hasClass(this.GROUP_TAB_BUTTON_CLASS)) {
          this.privateRequest.handleGroupTabClick(e);
        }
        if ($element.hasClass(this.PRIVATE_TAB_BUTTON_CLASS)) {
          this.privateRequest.handlePrivateTabClick(e);
        }
      });
    });
  };
}
